import { render, staticRenderFns } from "./CDEKEditing.vue?vue&type=template&id=516eeab2&scoped=true"
import script from "./CDEKEditing.vue?vue&type=script&lang=js"
export * from "./CDEKEditing.vue?vue&type=script&lang=js"
import style0 from "./CDEKEditing.vue?vue&type=style&index=0&id=516eeab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516eeab2",
  null
  
)

export default component.exports